/**
 * @description: 存储用户信息
 * @return {Promise<boolean>}
 */
export const setUserInfo = () => {
  const obj = {
    action: 'getUserInfo',
    _action: '',
    onlyGetId: 1, // 0、重新登录并返回用户信息 1、仅获取用户信息
    loginBackToPage: '', //登录后跳转页面 如果为空 返回进入页面 如果需要跳转其他页面 需要使用其他方法 包装H5链接  方法待定，咨询怡玥
    extra: '' // 而外参数，原路返回
  };
  return new Promise((resolve, reject) => {
    try {
      window.AmapApp.bridge.send(obj, (res) => {
        const info = (res && res.content) || {};
        sessionStorage.setItem('getUserInfo', JSON.stringify(info));
        resolve(true);
      });
    } catch (e) {
      console.log('setUserInfo-error', e);
      reject(false);
    }
  });
};

/**
 * @description: 获取用户信息
 * @return {*}
 */
export const getUserInfo = () => {
  return JSON.parse(sessionStorage.getItem('getUserInfo') || '{}');
};
